import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { CRITERIA_SELECTORS } from 'Views/booking/constants';
import { ICONS } from 'Components/utils/icon/icons';
import { pluralizeLabel } from 'Utils/label/labelUtils';
import { t } from 'Src/i18n';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  adults: number;
  className?: string;
  kids: number;
};
export const AttendeesSummary = ({ adults, className, kids }: Props) => (
  <div
    className={classnames('flex items-center gap-10 text-14', className)}
    data-testid={CRITERIA_SELECTORS.ATTENDEES}
  >
    <Icon className="shrink-0 text-sienna" hasRtl name={ICONS.PEOPLE_DOUBLE} width="1.875rem" />
    <div>
      <p data-testid="PackagePriceSummary-guestsItem" key="adults">
        <span className="font-bold text-sienna">{adults}</span>
        {` ${pluralizeLabel(t('booking.common.adult'), t('booking.common.adults'), adults)}`}
      </p>
      {kids > 0 && (
        <p data-testid="PackagePriceSummary-guestsItem" key="children">
          <span className="font-bold text-sienna">{kids}</span>
          {` ${pluralizeLabel(t('booking.common.child'), t('booking.common.children'), kids)}`}
        </p>
      )}
    </div>
  </div>
);
